window.PLUG = window.PLUG || Object.create(null);
//
// 1. Utilities
//
const addItemsToCart = function (body, cb) {
    const config = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/javascript',
            'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(body)
    };

    fetch(location.origin + "/cart/add.js", config)
        .then(res => res.json())
        .then(data => {
            if (data.message === "Cart Error") {
                const regex = /You can't add more [\w\W]+to the cart/g;
                throw new Error(
                    data.description.match(regex)
                    ? data.description.replace("You can't add more", "You can't add that many")
                    : data.description
                );
            }
            return cb(data);
        })
        .catch((error) => {
            return cb(undefined, error);
        });
};

const afterNextFrame = function (cb) {
    window.requestAnimationFrame(() => {
        setTimeout(cb, 0);
    });
};

const getAllNonBuiltInProperties = (obj) => {
    const properties = new Set();

    (function getNonBuiltInProperties(obj) {
        Reflect.ownKeys(obj).forEach(key => {
            properties.add([obj, key]);
        });

        obj = Reflect.getPrototypeOf(obj);

        if (obj !== Object.prototype) {
            getNonBuiltInProperties(obj);
        }
    })(obj);

    return properties;
};

/**
 * Called in the constructor of many of our classes as a convenience.
 *
 * @param {Object} obj - Typically a class.
 * @param {string|regex} include
 * @param {string|regex} exclude
 * @returns {Object}
 */
const bindThisToAllMethods = function (obj, include, exclude) {
    const filter = (key) => {
        const match = (pattern) => (
            typeof pattern === "string"
                ? key === pattern
                : pattern.test(key)
        );
        return (
            include ? include.some(match)
                : exclude ? !exclude.some(match)
                    : true
        );
    };

    for (const [object, key] of getAllNonBuiltInProperties(obj.constructor.prototype)) {
        if (key === "constructor" || !filter(key)) {
            continue;
        }

        const descriptor = Reflect.getOwnPropertyDescriptor(object, key);

        if (descriptor && typeof descriptor.value === "function") {
            obj[key] = obj[key].bind(obj);
        }
    }

    return obj;
};

const loadingSvg = function () {
    const ns = "http://www.w3.org/2000/svg";

    const svg = document.createElementNS(ns, "svg");
    svg.setAttribute("aria-hidden", "true");
    svg.setAttribute("focusable", "false");
    svg.setAttribute("role", "presentation");
    svg.setAttribute("class", "icon spinner-icon");
    svg.setAttribute("viewBox", "0 0 20 20");

    const path = document.createElementNS(ns, "path");
    path.setAttribute("d", "M7.229 1.173a9.25 9.25 0 1 0 11.655 11.412 1.25 1.25 0 1 0-2.4-.698 6.75 6.75 0 1 1-8.506-8.329 1.25 1.25 0 1 0-.75-2.385z");
    path.setAttribute("fill", "currentColor");

    svg.appendChild(path);

    const wrapper = document.createElement("span");
    wrapper.setAttribute("data-loader", true);
    wrapper.className = "is-hidden";
    wrapper.appendChild(svg);

    return wrapper;
};

/**
 * Takes a container element and starts the loading animation if 'loading' is true, otherwise
 * it stops the loading animation. If there is no load svg inside the button, we build one.
 *
 * @param {HTMLElement} container
 * @param {boolean} loading
 */
const setLoadingState = function (container, loading) {
    let loader = container.querySelector("[data-loader]");
    let content = container.querySelector("[data-content]");

    if (!loader) {
        loader = loadingSvg();

        if (!content) {
            content = document.createElement("span");
            content.setAttribute("data-content", "true");

            let k = 0;
            while (k < container.childNodes.length) {
                let childNodeK = container.childNodes[k];
                if (childNodeK.nodeType === 1 || childNodeK.nodeType === 3) { // If it is an element or text node.
                    content.appendChild(childNodeK);
                }
                k += 1;
            }

            container.appendChild(content);
        }

        container.appendChild(loader);
    }

    if (!content) { // Loader is present but content is not.
        return;
    }

    if (loading) {
        container.disabled = true;
        content.style.opacity = "0";
        loader.classList.remove("is-hidden");
    } else {
        container.disabled = false;
        loader.classList.add("is-hidden");
        content.style.opacity = "1";
    }
};

/**
 *
 * @param {Array.<string>} eventNames
 * @returns {PubSub}
 */
const eventPubSub = function (eventNames) {
    const events = Object.create(null);

    eventNames.forEach(name => {
        events[name] = {
            subscribers: [],
        };
    })

    return Object.freeze({
        // The string ", " can be used to dilineate multiple event names.
        on: function (eventName, callback) {
            if (eventName.includes(", ")) {
                eventName.split(", ").forEach((name) => {
                    events[name].subscribers.push(callback);
                });
            } else {
                events[eventName].subscribers.push(callback);
            }
        },
        emit: function (eventName, data) {
            events[eventName].subscribers.forEach(callback => {
                setTimeout(callback, 0, data);
            });
        },
        removeAll: function () {
            eventNames.forEach(name => {
                events[name].subscribers = [];
            });
        }
    });
};

PLUG.utils = Object.freeze({
    addItemsToCart,
    afterNextFrame,
    bindThisToAllMethods,
    setLoadingState,
    eventPubSub,
});
